module.exports = __webpack_public_path__ + "media/images/icons/beaker-6d28774d3f2e245ee20a013bdc03dc1d.svg";